function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import KZUIComponent from '../base';

var animateScrollTop = function animateScrollTop(element, value, duration) {
  var targetDom = element;

  var createTime = function createTime() {
    return new Date().getTime();
  };

  var startPosition = element.scrollTop;
  var endPosition = parseInt(value, 10) * 28;
  var offset = endPosition - startPosition;
  var startTime = createTime();
  var timerId = setInterval(function () {
    var remaining = Math.max(0, startTime + duration - createTime());
    var percent = 1 - (remaining / duration || 0);
    var now = offset * percent + startPosition;
    targetDom.scrollTop = now;

    if (percent === 1) {
      clearInterval(timerId);
      timerId = null;
    }
  }, 16);
};

var paddingZero = function paddingZero(number) {
  return number < 10 ? "0".concat(number) : "".concat(number);
};

var clsPrefix = 'kui-time-picker';

var TimePanel = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(TimePanel, _KZUIComponent);

  var _super = _createSuper(TimePanel);

  function TimePanel(props) {
    var _this;

    _classCallCheck(this, TimePanel);

    _this = _super.call(this, props);

    _this.autoBind('handleClose', 'handleHourClick', 'handleMinuteClick', 'handleSecondClick', 'animate');

    _this.hours = [];

    for (var i = 0; i < 24; i += 1) {
      _this.hours.push(i);
    }

    _this.minutes = [];

    for (var _i = 0; _i < 60; _i += 1) {
      _this.minutes.push(_i);
    }

    _this.seconds = _toConsumableArray(_this.minutes);
    return _this;
  }

  _createClass(TimePanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.animate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.animate();
    }
  }, {
    key: "animate",
    value: function animate() {
      var _this$props = this.props,
          hour = _this$props.hour,
          minute = _this$props.minute,
          second = _this$props.second;
      animateScrollTop(this.hourParent, hour, 200);
      animateScrollTop(this.minuteParent, minute, 200);
      animateScrollTop(this.secondParent, second, 200);
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.props.onClose();
    }
  }, {
    key: "handleHourClick",
    value: function handleHourClick(value) {
      var _this$props2 = this.props,
          minute = _this$props2.minute,
          second = _this$props2.second;
      this.props.onChange({
        hour: value,
        minute: minute,
        second: second
      });
    }
  }, {
    key: "handleMinuteClick",
    value: function handleMinuteClick(value) {
      var _this$props3 = this.props,
          hour = _this$props3.hour,
          second = _this$props3.second;
      this.props.onChange({
        hour: hour,
        minute: value,
        second: second
      });
    }
  }, {
    key: "handleSecondClick",
    value: function handleSecondClick(value) {
      var _this$props4 = this.props,
          hour = _this$props4.hour,
          minute = _this$props4.minute;
      this.props.onChange({
        hour: hour,
        minute: minute,
        second: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          hour = _this$props5.hour,
          minute = _this$props5.minute,
          second = _this$props5.second;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-time-panel")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-header")
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-panel-header-title")
      }, "\u9009\u62E9\u65F6\u95F4"), /*#__PURE__*/React.createElement(Icon, {
        iconClass: "kz-e-close-new",
        onClick: this.handleClose
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-body")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-body-item"),
        ref: function ref(c) {
          _this2.hourParent = c;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-item-container")
      }, this.hours.map(function (item) {
        return /*#__PURE__*/React.createElement(PickItem, {
          key: "hour-".concat(item),
          onClick: _this2.handleHourClick,
          value: item,
          active: item === hour
        });
      }))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-body-item"),
        ref: function ref(c) {
          _this2.minuteParent = c;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-item-container")
      }, this.minutes.map(function (item) {
        return /*#__PURE__*/React.createElement(PickItem, {
          key: "minute-".concat(item),
          onClick: _this2.handleMinuteClick,
          value: item,
          active: item === minute
        });
      }))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-body-item"),
        ref: function ref(c) {
          _this2.secondParent = c;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-item-container")
      }, this.seconds.map(function (item) {
        return /*#__PURE__*/React.createElement(PickItem, {
          key: "second-".concat(item),
          onClick: _this2.handleSecondClick,
          value: item,
          active: item === second
        });
      })))));
    }
  }]);

  return TimePanel;
}(KZUIComponent);

TimePanel.propTypes = {
  hour: PropTypes.number.isRequired,
  minute: PropTypes.number.isRequired,
  second: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

var PickItem = function PickItem(_ref) {
  var active = _ref.active,
      value = _ref.value,
      onClick = _ref.onClick;

  var handleClick = function handleClick() {
    onClick(value);
  };

  if (active) {
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(clsPrefix, "-active"),
      onClick: handleClick
    }, paddingZero(value));
  }

  return /*#__PURE__*/React.createElement("span", {
    onClick: handleClick
  }, paddingZero(value));
};

PickItem.propTypes = {
  active: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired
};
export default TimePanel;